import mediaPipePose from "./util/mediaPipePose";
import CrashRecoveryService from "./services/CrashRecoveryService"

class ondemandCamera {
  constructor() {
    this.ondemandCamera = {};
    this.userPermision = false;
    this.loadedmedia = false;
    this.listOfCameras = [];
    this.listOfSpeakers = [];
    this.currentCameraIndex = 0;

    this.cameraActive = false;

    this.audioSaidStart = false;
    this.audioSaidLight = false;

    this.pickOnce = true;

    this.localStream = null;

    this.mediaPipePose = new mediaPipePose();

    this.repeatedDetection = false;
    this.vwidth = "100vw";
    this.vheight = "100vw";
    this.aspectRatio = "16/9";

    this.framesArray = [];

    this.flutterCanvas = false;
    this.drawContext = false;
    this.drawContext1 = false;

    this.hideMasks = [];
    this.listStickMan = [];
    this.doHiding = false;

    this.useWidth = window["electron"] ? 1280 : window.innerWidth;
    this.useHeight = window["electron"] ? 720 : window.innerHeight;

    this.sizeSetupOnce = false;

    this.simpleCanvas = document.createElement("CANVAS");
    this.simpleCanvas.width = this.useWidth;
    this.simpleCanvas.height = this.useHeight;
    this.simpleCtx = this.simpleCanvas.getContext("2d");
    //this.simpleCtx.translate(this.useWidth, 0);
    //this.simpleCtx.scale(-1, 1);
    this.listOfMediaTracks = [];
	
	this.APIURL = window.location.href.indexOf('uat') > 0 || window.location.href.indexOf('weborik') > 0 ? 'https://uatapi.virdiohealth.com' : 'https://api.virdiohealth.com';
  }

  hasGetUserMedia = () => {
    return !window["electron"] || !!(navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
  };

  getUserPermission = (cam, callDistanceCheck, f) => {
    /* var errorCallback = function (e) {
      console.log("Rejected!", e);

      f(false);
    }; */

    document.querySelector("#agora_ondemand_local").innerHTML = "";
    if (document.querySelector('.agora_ondemand_local_allow')) { document.querySelector('.agora_ondemand_local_allow').style.display = 'none'; }

    var makeActive = () => {
      this.cameraActive = true;
    };

    var successCallback = function (e) {
      console.log("Accessed", e);
      if (window.cameraIsReady && !!document.querySelector("body.cameraSetupScreen")) {
        makeActive();
        console.log("Ready to begin");
        window.cameraIsReady();
      }

      f(true);
    };

    var constraints = {
      audio: false,
      video: {
        width: { min: 640, ideal: 1920 },
        height: { min: 360, ideal: 1080 },
        aspectRatio: 16 / 9,
        facingMode: "user"
      },
    };

    if (cam && cam.deviceId) {
      constraints = { video: { width: { min: 640, ideal: 1920 }, height: { min: 360, ideal: 1080 }, deviceId: { exact: cam.deviceId } } };
    }

    console.log('GET CAM', constraints, cam);

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(async (localMediaStream) => {
        console.log('GOT', localMediaStream);
        const videoTrack = localMediaStream.getVideoTracks()[0];

        let currentLabel = '';
        if (videoTrack && videoTrack.label) {
          currentLabel = videoTrack.label;
          if (window.updateCurrentCamera) {
            window.updateCurrentCamera(videoTrack.label);
          }
        }

        // Ensure we have up-to-date device info with labels
        let devices = [];
        try {
          devices = await navigator.mediaDevices.enumerateDevices();
        } catch (e) {
          console.warn("enumerateDevices failed, cannot auto-switch from iPhone camera:", e);
        }

        // Refresh listOfCameras with labels
        this.listOfCameras = devices.filter((d) => d.kind === "videoinput");

        // --- NEW LOGIC: if first picked camera is an iPhone, auto-switch ---
        if (/iphone/i.test(currentLabel) && this.pickOnce == true) {
          console.log("Detected iPhone camera as first pick. Looking for a non-iPhone camera...");

          this.pickOnce = false;

          const nonIphoneCam = this.listOfCameras.find((cam) => !/iphone/i.test((cam.label || "")));

          if (nonIphoneCam) {
            console.log("Switching to non-iPhone camera:", nonIphoneCam.label || nonIphoneCam.deviceId);

            // Stop the temporary iPhone stream
            localMediaStream.getVideoTracks().forEach((t) => t.stop());

            // Use your existing setVideoDevice logic
            // setVideoDevice expects something like { deviceId: [ deviceIdString ] }
            this.setVideoDevice({ deviceId: [nonIphoneCam.deviceId] });

            // Don't continue with the iPhone stream UI setup
            return;
          } else {
            console.log("No non-iPhone camera found. Staying on iPhone camera.");
          }
        }
        // --- END NEW LOGIC ---

        const selectedCam = this.listOfCameras.find((cam) => currentLabel == cam.label);
        if (selectedCam && selectedCam.deviceId) {
          localStorage.setItem("virtual_camera_selected", selectedCam.deviceId);
        }

        document.querySelector("#agora_ondemand_local").innerHTML = "<video playsinline webkit-playsinline muted autoplay></video>";
        var video = document.querySelector("#agora_ondemand_local video");
        video.srcObject = localMediaStream;
        this.listOfMediaTracks.push(localMediaStream);
        this.localStream = localMediaStream;

        video.onloadedmetadata = (e) => {
          successCallback(e);
          //its breaking code on configure ondemand
          if (window.cameraDistanceCheck && callDistanceCheck) {
            console.log("Ready, call camera distance check #OD-CAM");
            window.cameraDistanceCheck();
          }
          // Resize camera view immediately for iPhone Safari on exercise screen only
          if (this.isIPhoneSafari() && callDistanceCheck) {
            this.stretchToFill();
          }
        };
      })
      .catch((err) => {
        // errorCallback;
        f(false);
        console.log(err);

        if (document.querySelector('.agora_ondemand_local_allow')) { document.querySelector('.agora_ondemand_local_allow').style.display = 'block'; }
      });
  };

  getListOfCameras = (callback) => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      var videoSources = [];
      var speakerSources = [];
      for (var i = 0; i < devices.length; i++) {
        var device = devices[i];
        if (device.kind === "videoinput") {
          videoSources.push(device);
        } else if (device.kind === "audiooutput") {
          speakerSources.push(device);
        }
      }

      this.listOfCameras = videoSources;

      try {
        if (window.updateCameraList && this.listOfCameras && JSON.stringify(this.listOfCameras)) {
          window.updateCameraList(JSON.stringify(this.listOfCameras));
        }
      } catch (e) { console.error('got error', e); }

      if (callback) {
        callback();
      }
    });
    return JSON.stringify(this.listOfCameras);
  };

  getListOfSpeakers = (callback) => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      var speakerSources = [];
      for (var i = 0; i < devices.length; i++) {
        var device = devices[i];
        if (device.kind === "audiooutput") {
          speakerSources.push(device);
        }
      }

      this.listOfSpeakers = speakerSources;
      console.log("this.listOfSpeakers", this.listOfSpeakers);

      if (window.updateSpeakerList) {
        window.updateSpeakerList(JSON.stringify(this.listOfSpeakers));
      }
      //callback();
    });
    return JSON.stringify(this.listOfSpeakers);
  };

  speakerTestOnDemand = () => {
    this.audio = new Audio("assets/assets/dashboard/Stream/test_speaker.mp3");
    if (this.getLastPickedSpeaker()) {
      this.audio.setSinkId(this.getLastPickedSpeaker()["deviceId"]);
    }
    this.audio.play();
    setTimeout(() => {
      this.audio.pause();
      window.playSoundSpeaker(0);
    }, 5000);
  };

  stopSpeakerTestOnDemand = () => {
    if (this.audio) {
      this.audio.pause();
    } else if (this.audio === undefined) {
      console.log(this.audio);
    }
  };

  getLastPickedCamera = () => {
    var pickedId = localStorage.getItem("virtual_camera_selected");

    this.currentCameraIndex = 0;
    if (!pickedId && this.listOfCameras.length > 0) {
      return this.listOfCameras[0];
    }

    if (!pickedId && this.listOfCameras.length == 0) {
      return false;
    }

    var returnCam = this.listOfCameras[0];

    var i = 0;
    this.listOfCameras.forEach((cam) => {
      if (cam.deviceId == pickedId) {
        returnCam = cam;
        this.currentCameraIndex = i;
      }
      i++;
    });

    localStorage.setItem("virtual_camera_selected", returnCam && returnCam.deviceId ? returnCam.deviceId : "");

    return returnCam;
  };

  startStream = () => {
    if (this.cameraActive) {
      console.log("Stream started already....");
      if (window.cameraIsOn) { window.cameraIsOn(); }
      setTimeout(() => {
        if (window.cameraDistanceCheck) {
          console.log("Ready, call camera distance check #OD-CAM");
          window.cameraDistanceCheck();
          this.getListOfCameras();
        }
      }, 2000);
      return true;
    }

    console.log("called start");
    if (!this.hasGetUserMedia()) {
      console.log("Not allowed");
    } else {
      console.log("called list");
      this.getListOfCameras(() => {
        console.log("called back");
        var pickedCamera = this.getLastPickedCamera();

        this.getUserPermission(pickedCamera, true, (res) => {
          if (res) {
            console.log("Stream started....");
            this.cameraActive = true;
            if (window.cameraIsOn) { window.cameraIsOn(); }
          } else {
            // Ask for permission
            console.log("Camera REJECTED");
          }
        });
      });
    }
  };

  turnOffCamera = () => {
    setTimeout(() => {
      for (var videos of this.listOfMediaTracks) {
        var videoTracks = videos.getVideoTracks()[0];
        videoTracks.stop();
      }
      this.cameraActive = false;


      try {
        if (window.destroyOwnedResources) {
          // window.destroyOwnedResources();
        }
      } catch (e) {
        console.log(e);
      }

    }, 1000);
  };

  closeStream = (noHideOD) => {
    console.log("Close...");
    this.repeatedDetection = false;
    document.body.classList = [];

    setTimeout(() => {
      try {
        if (this.localStream) {
          this.localStream.getVideoTracks()[0].stop();
        }

        if (document.querySelector("#agora_ondemand_local video")) {
          document.querySelector("#agora_ondemand_local video").srcObject.getVideoTracks()[0].stop();
        }
      } catch (e) {
        console.log("stop error", e);
      }

      this.cameraActive = false;

      if (!noHideOD) {
        document.querySelector("#player_ondemand").innerHTML = "";
      }
    }, 1000);

    setTimeout(() => {
      document.querySelector("#agora_ondemand_local").innerHTML = "";
    }, 500);
  };

  getMediaPipePoints = (returnFrame) => {
    // Get user camera

    if (document.querySelector("#agora_ondemand_local video")) {
      if (returnFrame && window.callback_frame) {
        var canvas = document.createElement("canvas");
        canvas.width = this.useWidth / 2;
        canvas.height = this.useHeight / 2;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(document.querySelector("#agora_ondemand_local video"), 0, 0, this.useWidth / 2, this.useHeight / 2);

        var lastFrame = canvas.toDataURL();
        window.callback_frame(JSON.stringify([lastFrame, new Date().toISOString(), returnFrame]));
      }

      if (this.isIPhoneSafari()) {
        this.stretchToFill();
      }

      this.mediaPipePose.getPose(document.querySelector("#agora_ondemand_local video"), (poseLandmarks, poseLandmarksW) => {
        if (window.callback_MP) {
          this.updateStickManInternally(poseLandmarks);
          window.callback_MP(JSON.stringify(poseLandmarks));
        }

        /* if (window.callback_MPW) {
          window.callback_MPW(JSON.stringify([{ screen: poseLandmarks, world: poseLandmarksW }]));
        } */
      });

      //Check WebGL support
      /*      if(!window.WebGLRenderingContext){
         console.log("WebGL is NOT supported!");
         window.recieveSupportMessage();
     }    */
      /*       canvas.addEventListener('webglcontextlost', function(event){
        //handle context loss here
        event.preventDefault();
      },false); 
        
*/
    }
  };

  stretchToFill = () => {
    const thisVideo = document.querySelector("#agora_ondemand_local video");
    if (!thisVideo) return;
    const vw = thisVideo.videoWidth;
    const vh = thisVideo.videoHeight;
    if (!vw || !vh) return;

    // Lock layout box to intrinsic pixels so scale math is precise.
    thisVideo.style.width = vw + "px";
    thisVideo.style.height = vh + "px";

    const sx = window.innerWidth / vw;
    const sy = window.innerHeight / vh;

    // Center then stretch in BOTH axes
    thisVideo.style.transform = `translate(-50%, -50%) scale(${sx}, ${sy}) rotateY(180deg)`;

    document.querySelector("#agora_ondemand_local").classList.add("safariRotation");
  };

  isIPhoneSafari = () => {
    const ua = window.navigator.userAgent;

    // 1. Must be an iPhone (not iPad or Mac)
    const isIPhone = /iPhone/i.test(ua);
    const isIPad = /iPad/i.test(ua);
    const isMac = /Macintosh/i.test(ua) && "ontouchend" in document;

    // 2. Must be Safari (not Chrome, Firefox, Edge, or WebView)
    const isSafari =
      /Safari/i.test(ua) &&
      !/CriOS/i.test(ua) && // Chrome on iOS
      !/FxiOS/i.test(ua) && // Firefox on iOS
      !/EdgiOS/i.test(ua) && // Edge on iOS
      !/OPiOS/i.test(ua) && // Opera on iOS
      !/DuckDuckGo/i.test(ua); // DDG browser

    return (isIPhone || isMac) && isSafari && !isIPad;
  };

  startVirtualFullDetection = (doFullHide) => {
    if (this.repeatedDetection) {
      return;
    }
    this.doHiding = false;
    if (doFullHide) {
      if (window["electron"]) {
        document.body.classList = ["fullDetectionRunning"];
      } else {
        document.body.classList = ["fullDetectionRunningWeb"];
      }
      this.hideMasks = [];
      this.listStickMan = [];
      this.doHiding = true;
    }

    this.repeatedDetection = true;
    window.onresize = () => {
      this.flutterCanvas = false;
      this.drawContext = false;
      this.drawContext1 = false;

      if (this.isIPhoneSafari()) {
        this.stretchToFill();
      }
    };
    this.loopVirtualFullDetection();
  };

  canvasCapture = () => {
    /* if (document.querySelector("#agora_ondemand_local video")) {
      var canvas = document.createElement("canvas");
      canvas.width = this.useWidth / 2;
      canvas.height = this.useHeight / 2;
      var objContext = canvas.getContext("2d");
      objContext.drawImage(document.querySelector("#agora_ondemand_local video"), 0, 0, this.useWidth / 2, this.useHeight / 2);
      var pixelBuff = objContext.getImageData(0, 0, this.useWidth / 2, this.useHeight / 2);
      var uint8ClampedArray = pixelBuff.data;
      var arrayBuffer = uint8ClampedArray.buffer;

      if (arrayBuffer != null && window.checkScreenContrast) {
        window.checkScreenContrast(arrayBuffer);
      }
    } */
  };

  takeScreenshot = () => {
    if (document.querySelector("#agora_ondemand_local video")) {
      var canvas = document.createElement("canvas");
      canvas.width = 600;
      canvas.height = 250;
      var objContext = canvas.getContext("2d");
      objContext.drawImage(document.querySelector("#agora_ondemand_local video"), 0, 0, 600, 250);

      var img = canvas.toDataURL();
      img = img.split(",")[1];

      if (img != null && window.recieveScreenshot) {
        window.recieveScreenshot(img);
      }
    }
  };

  loopVirtualFullDetection = () => {
    if (this.repeatedDetection) {
      var vidElm = document.querySelector("#agora_ondemand_local video");
      if (this.drawContext1) {
        this.drawContext1.drawImage(vidElm, 0, 0, vidElm.videoWidth, vidElm.videoHeight, 0, 0, this.useWidth, this.useHeight);
      }
      this.mediaPipePose.getPose(vidElm, (poseLandmarks, poseLandmarksW) => {
        if (window.callback_MP && this.repeatedDetection) {
          this.updateStickManInternally(poseLandmarks);
          window.callback_MP(JSON.stringify(poseLandmarks));

          if (this.doHiding) {
            this.drawCanvasFromFlutter();
          }
        }

        /*
        if (window.callback_MPW && window['electron'] ) {
          window.callback_MPW(JSON.stringify([{ screen: poseLandmarks, world: poseLandmarksW }]));
        }*/

        if (this.repeatedDetection) {
          if (window["electron"]) {
            requestAnimationFrame(this.loopVirtualFullDetection);
          } else if (window["isDesktopWeb"]) {
            setTimeout(this.loopVirtualFullDetection, 40);
          } else if (window.isIOSSafari) {
            setTimeout(this.loopVirtualFullDetection, 150);
          } else {
            setTimeout(this.loopVirtualFullDetection, 100);
          }
        }
      });
    }
  };

  stopVirtualFullDetection = () => {
    document.body.classList = [];
    this.repeatedDetection = false;
    window.stopPoseReload();
  };

  updateNewMP = (objMP) => {
    this.mediaPipePose = new mediaPipePose();
  };

  drawCanvasFromFlutter = () => {
    if (!this.flutterCanvas || !this.drawContext || !this.drawContext1) {
      this.flutterCanvas = document.querySelector("flt-glass-pane").shadowRoot.querySelector("canvas");
      this.drawContext = document.querySelector("#canvas-flutter").getContext("2d");
      this.drawContext1 = document.querySelector("#canvas-user").getContext("2d");
    }

    if (this.flutterCanvas && this.drawContext) {
      var offsetFlutter = this.flutterCanvas.style.transform && this.flutterCanvas.style.transform.split(", ").length > 1 && this.flutterCanvas.style.transform.split(", ")[1].split("px").length > 1 ? this.flutterCanvas.style.transform.split(", ")[1].split("px")[0] : 0;

      var canvasSizeUp = window.innerWidth / parseInt(this.flutterCanvas.style.width);
      var canvasSizeUp1 = window.innerHeight / parseInt(this.flutterCanvas.style.height);
      var canvasSizeUp2 = parseInt(this.flutterCanvas.style.width) / this.flutterCanvas.width;

      this.drawContext.clearRect(0, 0, this.useWidth, this.useHeight);

      if (!window["electron"]) {
        if (this.sizeSetupOnce == false) {
          this.sizeSetupOnce = true;

          document.querySelector("#canvas-user").width = this.useWidth;
          document.querySelector("#canvas-user").height = this.useHeight;
          document.querySelector("#canvas-flutter").width = this.useWidth;
          document.querySelector("#canvas-flutter").height = this.useHeight;

          // document.querySelector("#canvas-user").style.display = 'none';
        }
      } else {
        this.drawContext.drawImage(this.flutterCanvas, 0, (parseInt(offsetFlutter) / canvasSizeUp2) * -1, this.flutterCanvas.width * canvasSizeUp, this.flutterCanvas.height * canvasSizeUp1, 0, 0, this.useWidth, this.useHeight);
      }

      if (window["electron"] && window["poseSegmentationMask"]) {
        this.simpleCtx.clearRect(0, 0, this.useWidth, this.useHeight);
        this.hideMasks.forEach((itm) => {
          if (itm["x1"] > itm["x2"]) {
            var x1 = itm["x1"];
            itm["x1"] = itm["x2"];
            itm["x2"] = x1;
          }

          var pRec = {
            x1: itm["x1"] - 10,
            y1: itm["y1ret"] ? itm["y1ret"] : itm["y1"] - 10,
            w: itm["x2"] - itm["x1"] + 40,
            h: (itm["y2ret"] ? itm["y2ret"] : itm["y2"]) - (itm["y1ret"] ? itm["y1ret"] : itm["y1"]) + 40,
          };

          var screenOffsetX = this.useWidth / window.innerWidth;
          var screenOffsetY = this.useHeight / window.innerHeight;

          this.simpleCtx.fillRect(pRec["x1"] * screenOffsetX, pRec["y1"] * screenOffsetY, pRec["w"] * screenOffsetX, pRec["h"] * screenOffsetY);
        });

        this.simpleCtx.save();
        this.simpleCtx.globalCompositeOperation = "destination-in";
        this.simpleCtx.translate(this.useWidth, 0);
        this.simpleCtx.scale(-1, 1);
        this.simpleCtx.drawImage(window["poseSegmentationMask"], 0, 0, this.useWidth, this.useHeight);
        this.simpleCtx.globalCompositeOperation = "source-over";
        this.simpleCtx.restore();

        this.drawContext.save();
        this.drawContext.globalCompositeOperation = "destination-out";
        this.drawContext.drawImage(this.simpleCanvas, 0, 0, this.useWidth, this.useHeight);
        this.drawContext.globalCompositeOperation = "source-over";
        this.drawContext.restore();
      }

      if (this.listStickMan && this.listStickMan.length > 0) {
        this.drawContext.beginPath();
        this.drawContext.strokeStyle = "rgba(0, 209, 209, 0.7)";
        this.drawContext.lineWidth = 7;
        this.drawContext.lineCap = "round";

        // before drawing this frame
        const v = document.querySelector("#agora_ondemand_local video");
        const c = this.drawContext.canvas;

        const vRect = v.getBoundingClientRect(); // video’s on-screen box (CSS px)
        const cRect = c.getBoundingClientRect(); // canvas’ on-screen box (CSS px)

        // canvas CSS→pixel multipliers (handles devicePixelRatio)
        const mx = c.width / cRect.width;
        const my = c.height / cRect.height;

        // offset from canvas origin to video origin, in canvas pixels
        const ox = (vRect.left - cRect.left) * mx;
        const oy = (vRect.top - cRect.top) * my;

        // --- lines ---
        this.drawContext.beginPath();
        this.drawContext.fillStyle = "rgba(7, 255, 255, 1)";
        for (const itm of this.listStickMan) {
          const x1 = ox + itm["x1"] * vRect.width * mx; // no mirror
          const y1 = oy + itm["y1"] * vRect.height * my;
          const x2 = ox + itm["x2"] * vRect.width * mx;
          const y2 = oy + itm["y2"] * vRect.height * my;

          this.drawContext.moveTo(x1, y1);
          this.drawContext.lineTo(x2, y2);
        }
        this.drawContext.stroke();

        // --- dots ---
        for (const itm of this.listStickMan) {
          const x1 = ox + itm["x1"] * vRect.width * mx;
          const y1 = oy + itm["y1"] * vRect.height * my;
          const x2 = ox + itm["x2"] * vRect.width * mx;
          const y2 = oy + itm["y2"] * vRect.height * my;

          this.drawContext.beginPath();
          this.drawContext.fillStyle = "rgba(7, 255, 255, 1)";
          this.drawContext.arc(x1, y1, 6, 0, 2 * Math.PI);
          this.drawContext.fill();

          this.drawContext.beginPath();
          this.drawContext.fillStyle = "rgba(7, 255, 255, 1)";
          this.drawContext.arc(x2, y2, 6, 0, 2 * Math.PI);
          this.drawContext.fill();
        }
      }
    }
  };

  updateMasksArray = (listMask) => {
    this.hideMasks = JSON.parse(listMask);
    console.log(this.hideMasks);
  };

  updateStickManArray = (listStickMan) => {
    this.listStickMan = JSON.parse(listStickMan);
    console.log("STICK MAN", this.listStickMan);
  };

  updateStickManInternally = (mplist) => {
    if (!mplist || mplist.length < 30 || !mplist[0]['x']) { return; }

    // Helper to safely extract x/y as number
    const getCoord = (idx, key) => Number(mplist?.[idx]?.[key] ?? 0.0);

    // Left arm
    const lShX = getCoord(12, 'x');
    const lShY = getCoord(12, 'y');

    const lElbX = getCoord(14, 'x');
    const lElbY = getCoord(14, 'y');

    const lWrX = getCoord(16, 'x');
    const lWrY = getCoord(16, 'y');

    // Right arm
    const rShX = getCoord(11, 'x');
    const rShY = getCoord(11, 'y');

    const rElbX = getCoord(13, 'x');
    const rElbY = getCoord(13, 'y');

    const rWrX = getCoord(15, 'x');
    const rWrY = getCoord(15, 'y');

    // Hips
    const rHipX = getCoord(23, 'x');
    const rHipY = getCoord(23, 'y');

    const lHipX = getCoord(24, 'x');
    const lHipY = getCoord(24, 'y');

    // Knees
    const lKneeX = getCoord(26, 'x');
    const lKneeY = getCoord(26, 'y');

    const rKneeX = getCoord(25, 'x');
    const rKneeY = getCoord(25, 'y');

    // Ankles
    const lAnkX = getCoord(28, 'x');
    const lAnkY = getCoord(28, 'y');

    const rAnkX = getCoord(27, 'x');
    const rAnkY = getCoord(27, 'y');

    // Midpoints (normalized)
    const midHipX = (lHipX + rHipX) / 2;
    const midHipY = (lHipY + rHipY) / 2;
    const midShoulderX = (lShX + rShX) / 2;
    const midShoulderY = (lShY + rShY) / 2;

    // Stickman lines (already normalized 0..1)
    const stickManLines = [
      { x1: lShX, y1: lShY, x2: rShX, y2: rShY },
      { x1: rHipX, y1: rHipY, x2: lHipX, y2: lHipY },

      { x1: lShX, y1: lShY, x2: lElbX, y2: lElbY },
      { x1: lElbX, y1: lElbY, x2: lWrX, y2: lWrY },

      { x1: rShX, y1: rShY, x2: rElbX, y2: rElbY },
      { x1: rElbX, y1: rElbY, x2: rWrX, y2: rWrY },

      { x1: rHipX, y1: rHipY, x2: rKneeX, y2: rKneeY },
      { x1: rKneeX, y1: rKneeY, x2: rAnkX, y2: rAnkY },

      { x1: lHipX, y1: lHipY, x2: lKneeX, y2: lKneeY },
      { x1: lKneeX, y1: lKneeY, x2: lAnkX, y2: lAnkY },

      { x1: midShoulderX, y1: midShoulderY, x2: midHipX, y2: midHipY }
    ];

    this.listStickMan = stickManLines;
  }


  getCurrentVideoDevice = () => {
    return JSON.stringify(this.getLastPickedCamera());
  };

  getCurrentSpeakerDevice = () => {
    return JSON.stringify(this.getLastPickedSpeaker());
  };

  getLastPickedSpeaker = () => {
    var pickedId = localStorage.getItem("virtual_speaker_selected");

    if (!pickedId) {
      return this.listOfSpeakers[0] ? this.listOfSpeakers[0] : null;
    }

    var returnSpe = this.listOfSpeakers[0];

    var i = 0;
    this.listOfSpeakers.forEach((spe) => {
      if (spe.deviceId === pickedId) {
        returnSpe = spe;
      }
      i++;
    });

    localStorage.setItem("virtual_speaker_selected", returnSpe && returnSpe.deviceId ? returnSpe.deviceId : "");

    return returnSpe;
  };

  cameraSetupStart = () => {
    setTimeout(() => {
      document.querySelector("html").classList = [];

      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";

      if (window.callbackOpenFlutter) {
        window.callbackOpenFlutter();
      }

      if (document.querySelector(".rom-test-start-button")) {
        document.querySelector(".rom-test-start-button").innerHTML = "Start Movement Test";
      }
    }, 100);
  };

  cameraSetupShow = () => {
    document.body.classList = ["cameraSetupScreen"];

    if (window.mayraCode && window.mayraCode.setIsVisible) {
      window.mayraCode.setIsVisible(true);
    }

    setTimeout(() => {
      document.querySelector("html").classList = [];

      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";
    }, 100);

    let noPermission = false;
    if (window.mayraCode && window.mayraCode.isEnabled) {
      window.mayraCode.setOnMicEnabled(null);
      window.mayraCode.setupGlobalVirtualListener();
      window.mayraCode.disableCallback();

      noPermission = setTimeout(() => {
        clearTimeout(noPermission);
        noPermission = false;

        window.mayraCode.startFlow("without_camera_permission");
        window.currentCommandsAudio = {
          START_TEST: () => {
            window.mayraCode.doSay("Great! Let's start the test.", () => {
              setTimeout(() => {
                document.body.classList.remove("videoplay-expanded");
                if (window.tipsClickNext) {
                  window.tipsClickNext();
                  window.mayraCode.disableCallback();
                  window.mayraCode.startFlow("start_silent");
                }
              }, 2000);
            });
          },
          MOVE_ON: () => {
            window.mayraCode.doSay("Great! Let's move on to the next step.", () => {
              document.body.classList.remove("videoplay-expanded");
              setTimeout(() => {
                if (window.tipsClickNext) {
                  window.tipsClickNext();
                  window.mayraCode.disableCallback();
                  window.mayraCode.startFlow("start_silent");
                }
              }, 2000);
            });
          },
          EXPAND_VIDEO: () => {
            window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
              document.body.classList.add("videoplay-expanded");
            });
          },
          EXPAND_CAMERA: () => {
            window.mayraCode.doSay("Sure! I'll expand the camera for you.", () => {
              document.body.classList.add("videoplay-expanded");
            });
          },
        };
      }, 2000);
    }

    this.getUserPermission(this.getLastPickedCamera(), false, (res) => {
      console.log("Camera picked");
      this.cameraActive = true;

      // if permission is received quickly - play with permission
      if (noPermission && window.mayraCode && window.mayraCode.isEnabled) {
        clearTimeout(noPermission);
        window.mayraCode.startFlow("camera_permission");
        window.currentCommandsAudio = {
          START_TEST: () => {
            window.mayraCode.doSay("Great! Let's start the test.", () => {
              document.body.classList.remove("videoplay-expanded");
              setTimeout(() => {
                if (window.tipsClickNext) {
                  window.tipsClickNext();
                  window.mayraCode.disableCallback();
                  window.mayraCode.startFlow("start_silent");
                }
              }, 2000);
            });
          },
          MOVE_ON: () => {
            window.mayraCode.doSay("Great! Let's move on to the next step.", () => {
              document.body.classList.remove("videoplay-expanded");
              setTimeout(() => {
                if (window.tipsClickNext) {
                  window.tipsClickNext();
                  window.mayraCode.disableCallback();
                  window.mayraCode.startFlow("start_silent");
                }
              }, 2000);
            });
          },
          EXPAND_VIDEO: () => {
            window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
              document.body.classList.add("videoplay-expanded");
            });
          },
          EXPAND_CAMERA: () => {
            window.mayraCode.doSay("Sure! I'll expand the camera for you.", () => {
              document.body.classList.add("videoplay-expanded");
            });
          },
        };
      }
    });
  };

  startMyraClass = () => {
    if (window.mayraCode && window.mayraCode.setOnMicEnabled && !window.mayraCode.isEnabled) {
      window.mayraCode.setOnMicEnabled(null);
      window.mayraCode.setOnMicEnabled((enabledBefore) => {
        console.log("Started Myra");
        window.mayraCode.setOnMicEnabled(null);

        window.mayraCode.setupGlobalVirtualListener();
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("start_silent");

        setTimeout(() => {
          window.mayraCode.doSay("{name}. | Nice to have you back! When you’re ready, press Start and I’ll be ready to guide you.", () => {
            window.mayraCode.setIsVisible(false);
          });
        }, 2000);
      });
      window.mayraCode.handleMicClick(true, true);
    }
  };

  startMyraClassSilent = () => {
    window.mayraCode.setOnMicEnabled(null);
    if (window.mayraCode && window.mayraCode.setOnMicEnabled && !window.mayraCode.isEnabled) {
      window.mayraCode.setOnMicEnabled((enabledBefore) => {
        console.log("Started Myra");
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("start_silent");
        window.mayraCode.setIsVisible(false);
      });
      window.mayraCode.handleMicClick(true, true);
    }
  };

  isMyraActive = () => {
    if (window.mayraCode && window.mayraCode.isEnabled) {
      return "yes";
    }

    return "no";
  };

  cameraSetupHide = () => {
    document.body.classList = [];
    this.closeStream();
    document.querySelector("#agora_ondemand_local").classList.remove("safariRotation");
  };

  cameraSetupHideCamera = () => {
    document.body.classList = [];
    if (this.isIPhoneSafari()) {
      this.stretchToFill();
    }
    //this.closeStream(true);
  };

  setVideoDevice = (deviceId) => {
    deviceId = Object.values(deviceId)[0] ? Object.values(deviceId)[0][0] : "";
    var returnCam = this.listOfCameras[0];

    var i = 0;
    this.listOfCameras.forEach((cam) => {
      if (cam.deviceId === deviceId) {
        returnCam = cam;
        this.currentCameraIndex = i;
      }
      i++;
    });

    localStorage.setItem("virtual_camera_selected", returnCam && returnCam.deviceId ? returnCam.deviceId : "");

    // Stop before start next
    try {
      if (this.localStream) {
        this.localStream.getVideoTracks()[0].stop();
        this.cameraActive = false;
      }
      if (document.querySelector("#agora_ondemand_local video")) {
        document.querySelector("#agora_ondemand_local video").srcObject.getVideoTracks()[0].stop();
      }
    } catch (e) {
      console.log("stop error", e);
    }

    console.log('PICKED', returnCam);

    this.getUserPermission(returnCam, false, (res) => {
      if (res) {
        console.log("Camera changed");
        this.cameraActive = true;
        if (window.cameraIsOn) { window.cameraIsOn(); }
      } else {
        console.log("Camera REJECTED");
        // Ask for permission
      }
    });
  };

  setSpeakerDevice = (deviceId) => {
    deviceId = Object.values(deviceId)[0] ? Object.values(deviceId)[0][0] : "";

    var returnSpeaker = this.listOfSpeakers[0];

    this.listOfSpeakers.forEach((spe) => {
      if (spe.deviceId === deviceId) {
        returnSpeaker = spe;
      }
    });

    localStorage.setItem("virtual_speaker_selected", returnSpeaker && returnSpeaker.deviceId ? returnSpeaker.deviceId : "");

    console.log("selll", returnSpeaker);
  };

  getAppVersion = () => {
    var allInfo = window.navigator.appVersion;
    var version = allInfo.split("VirdioHealth/");
    var splitVersion = version[1].split(".");
    var p = splitVersion[0] + "." + splitVersion[1] + "." + splitVersion[2];
    var splitVersion2 = p.split(" ");
    var formattedVersion = splitVersion2[0];

    return formattedVersion.toString();
  };

  getPlatform = () => {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (/Linux/.test(platform)) {
      os = "Linux";
    }

    return os;
  };

  saveToJSONFile = (filename, text) => {
    if (window["fsFile"] && !window["failedWrite"]) {
      try {
        var dateStr = new Date().toISOString().split("T")[0];
        window["fsFile"].writeFileSync(window["documentsPath"] + "/virdiovirtual/" + dateStr + "_" + filename, text + "\n", { flag: "a+" });
      } catch (e) {
        window["failedWrite"] = true;
        console.log("Failed to save the file!");
      }
    }
  };

  restartFlutterTransform = () => {
    if (!this.flutterCanvas) {
      this.flutterCanvas = document.querySelector("flt-glass-pane").shadowRoot.querySelector("canvas");
    }

    var offsetFlutter = this.flutterCanvas.style.transform && this.flutterCanvas.style.transform.split(", ").length > 1 && this.flutterCanvas.style.transform.split(", ")[1].split("px").length > 1 ? this.flutterCanvas.style.transform.split(", ")[1].split("px")[0] : 0;
    this.flutterCanvas.style.marginTop = parseInt(offsetFlutter) * -1 + "px";

    window.onresize = () => {
      this.flutterCanvas = false;
      this.drawContext = false;
      this.drawContext1 = false;
      this.restartFlutterTransform();
    };
  };

  checkIsSelf = () => {
    console.log("self called");
    window.loadedSelfCorrectly = 1;

    if (!!localStorage.getItem("loadSelf") && window.loadedROM) {
      window.loadedSelfCorrectly = 2;
      return JSON.stringify(window.loadedROM);
    }
    console.log("self no");
    return "no";
  };

  getSelfLevel = () => {
    return localStorage.getItem("loadSelf") ? localStorage.getItem("loadSelf") : "";
  };

  moveAfterAssesment = () => {
    if (!localStorage.getItem("loadSelf")) {
      return "no";
    }

    if (window.blockNextSelfCall) {
      console.warn('Called too soon');
      return "no";
    }

    console.log('---moveAfterAssesment');

    this.stopStartAudio();
    this.stopLightAudio();

    document.querySelector("html").classList = ["wait-flutter"];
    document.getElementById("assesmentDiv").style.display = "block";
    document.getElementById("OnDemandPlayingRoot").style.display = "none";

    if (window.doNextLocation) {
      // Stop all audio/video before navigating to symptoms screen
      if (window.stopAudio) {
        window.stopAudio();
      }

      // Stop all video elements
      const allVideos = document.querySelectorAll("video");
      allVideos.forEach((video) => {
        try {
          video.pause();
          video.currentTime = 0;
          console.log("Paused video element before symptoms screen:", video.id || video.src);
        } catch (err) {
          console.warn("Failed to pause video:", err);
        }
      });
      if (window.VoiceService) {
        window.VoiceService._pcmBuffer = null;
        window.VoiceService._pendingAudioUrls = [];
        window.VoiceService._awaitingPcmFinish = false;
        window.VoiceService._currentFlow = null;
      }

      if (window.audioPlayer) {
        try {
          if (window.audioPlayer.ttsPcmAbort) {
            window.audioPlayer.ttsPcmAbort();
          }
          if (window.audioPlayer.stop) {
            window.audioPlayer.stop();
          }
          if (window.audioPlayer.pcm) {
            window.audioPlayer.pcm.bufferTime = 0;
            window.audioPlayer.pcm.queuedSamples = 0;
            window.audioPlayer.pcm.active = false;

            if (window.audioPlayer.pcm.clearBuffer) {
              window.audioPlayer.pcm.clearBuffer();
            }
          }
        } catch (e) {
          console.warn("Error stopping audio player:", e);
        }
      }
      if (window.stopAudio) {
        try {
          window.stopAudio();
          console.log("Global audio system stopped");
        } catch (e) {
          console.warn("Failed to stop global audio:", e);
        }
      }
      window.currentCommandsAudio = {};
      window.currentFlow = null;

      if (window.mayraCode) {
        try {
          window.mayraCode.forceStop();
          window.mayraCode.disableCallback();
        } catch (e) {
          console.warn("Error stopping mayraCode:", e);
        }
      }
      document.body.classList.remove("videoplay-expanded");
      if (localStorage.getItem("runStep") == "2") {
        window.VoiceService._currentFlow = "symptom2"
        window.currentFlow = "symptom2"
        window.doNextLocation.replace("/feedback-2");
        setTimeout(() => {
          window.turnOffCamera();
          document.body.style = "";
        }, 3000);
      } else {
        window.VoiceService._currentFlow = "rpe"
        window.currentFlow = "rpe"
        window.doNextLocation.replace("/how-challenging");
      }
    }

    // window.location = 'https://virdiohealth.com/selfassesment/index.html?after&data='+localStorage.getItem('dataAfterInfo');
    return "yes";
  };

  moveAfterAssesmentSave = (dataInfo, dataInfo2) => {
    localStorage.setItem("dataAfterInfo", JSON.stringify(dataInfo2));
  };

  closeSelfVirtual = () => {
    document.querySelector("html").classList = ["wait-flutter"];


    console.log('---closeSelfVirtual');

    if (document.getElementById("assesmentDiv")) {
      document.getElementById("assesmentDiv").style.display = "block";
    }
    if (document.getElementById("OnDemandPlayingRoot")) {
      document.getElementById("OnDemandPlayingRoot").style.display = "none";
    }
    if (window.turnOffCamera) {
      window.turnOffCamera();
    }
    document.body.style = "";
    window.clickedOnceOpen = false;
  };

  restartSelfAsses = (passed) => {
    console.log("sent", passed);

    console.log('---restartSelfAsses');

    if (passed != "" && localStorage.getItem("runStep") == "2") {
      document.querySelector("html").classList = ["wait-flutter"];

      if (document.getElementById("assesmentDiv")) {
        document.getElementById("assesmentDiv").style.display = "block";
      }
      if (document.getElementById("OnDemandPlayingRoot")) {
        document.getElementById("OnDemandPlayingRoot").style.display = "none";
      }
      if (window.turnOffCamera) {
        window.turnOffCamera();
      }
      document.body.style = "";
      window.clickedOnceOpen = false;

      if (window.doNextLocation) {
        try {
          const assessmentData = JSON.parse(localStorage.getItem("assessmentData")) || {};
          assessmentData.symptomResponseConfirm = "WORSENED";
          localStorage.setItem("assessmentData", JSON.stringify(assessmentData));
          console.log("Auto-set 2nd symptom response to WORSENED due to skipped test");
        } catch (err) {
          console.error("Error setting auto WORSENED symptom response", err);
        }
        console.log("Stopping all media before navigation...");

        if (window.VoiceService && window.VoiceService._mediaRecorder) {
          try {
            const stream = window.VoiceService._mediaRecorder.stream;
            if (window.VoiceService._mediaRecorder.state === "recording") {
              window.VoiceService._mediaRecorder.stop();
            }
            if (stream && stream.getTracks) {
              stream.getTracks().forEach(track => {
                try {
                  track.stop();
                  track.enabled = false;
                } catch (e) {
                  console.warn("Failed to stop track:", e);
                }
              });
            }
            window.VoiceService._mediaRecorder = null;
            window.VoiceService._isListening = false;

            console.log("MediaRecorder stopped");
          } catch (e) {
            console.warn("Error stopping MediaRecorder:", e);
          }
        }
        if (window.VoiceService) {
          window.VoiceService._pcmBuffer = null;
          window.VoiceService._pendingAudioUrls = [];
          window.VoiceService._awaitingPcmFinish = false;
          window.VoiceService._currentFlow = null;
        }

        if (window.audioPlayer) {
          try {
            console.log("Stopping audio player...");

            // Abort PCM playback
            if (window.audioPlayer.ttsPcmAbort) {
              window.audioPlayer.ttsPcmAbort();
            }
            if (window.audioPlayer.stop) {
              window.audioPlayer.stop();
            }
            if (window.audioPlayer.pcm) {
              window.audioPlayer.pcm.bufferTime = 0;
              window.audioPlayer.pcm.queuedSamples = 0;
              window.audioPlayer.pcm.active = false;

              // Clear buffer if method exists
              if (window.audioPlayer.pcm.clearBuffer) {
                window.audioPlayer.pcm.clearBuffer();
              }
            }
            console.log("Audio player stopped");
          } catch (e) {
            console.warn("Error stopping audio player:", e);
          }
        }
        if (window.stopAudio) {
          try {
            window.stopAudio();
            console.log("Global audio system stopped");
          } catch (e) {
            console.warn("Failed to stop global audio:", e);
          }
        }
        console.log("Stopping all HTML5 media elements...");

        document.querySelectorAll("audio").forEach(audio => {
          try {
            audio.pause();
            audio.currentTime = 0;
            audio.src = "";
            audio.load();
          } catch (e) {
            console.warn("Failed to stop audio element:", e);
          }
        });

        document.querySelectorAll("video").forEach(video => {
          try {
            video.pause();
            video.currentTime = 0;
            video.muted = true;
            video.src = "";
            video.load();
          } catch (e) {
            console.warn("Failed to stop video element:", e);
          }
        });

        window.currentCommandsAudio = {};
        window.currentFlow = null;

        if (window.mayraCode) {
          try {
            window.mayraCode.forceStop();
            window.mayraCode.disableCallback();
          } catch (e) {
            console.warn("Error stopping mayraCode:", e);
          }
        }
        document.body.classList.remove("videoplay-expanded");
        console.log("All media cleanup complete, navigating...");
        // window.VoiceService.forceStop()
        // setTimeout(() => {
        //   window.VoiceService._resetAllState()
        //   window.VoiceService._ws = null;
        //   window.VoiceService.forceReconnect();
        // }, 1000);
        window.VoiceService._currentFlow = "personalize"
        window.currentFlow = "personalize"
        // 10. WAIT FOR ALL CLEANUP TO COMPLETE THEN NAVIGATE
        setTimeout(() => {
          window.doNextLocation.replace("/plan-recommendation");
        }, 500);
      } else {
        console.log("NOT DEFINED CORRECTLY");
      }
    } else {
      const flutterView = document.querySelector("flutter-view");
      if (flutterView) {
        flutterView.style.display = "none";
      }
      const loader = document.getElementById("flutter-loader");
      if (loader) loader.style.display = "none";

      // Reset flags
      window.isFlutterLoaded = false;
      window.savedDeeplink = "";

      // Show popup
      const popup = document.getElementById("restartPopup");
      if (popup) {
        popup.style.display = "flex";
        if (window.setRestartVisible) window.setRestartVisible(true);
        const okBtn = document.getElementById("restartOkBtn");
        okBtn.onclick = () => {
          popup.style.display = "none";
          localStorage.setItem('loadAfterReloadAutoHome', '1');
          window.location.replace(window.location.origin);
        };
      } else {
        // fallback if popup missing
        localStorage.setItem('loadAfterReloadAutoHome', '1');
        window.location.replace(window.location.origin);
      }
    }
  };

  cameraBoxPosition = (pos) => {
    console.log("Got ", pos);
    pos = JSON.parse(pos);
    document.getElementById("cameraCustomRules").innerHTML = `
		body.cameraSetupScreen #agora_ondemand_local video,
		body.cameraSetupScreen #agora_ondemand_local_waiting {
		  position: absolute;
		  left: ${pos.left}px;
		  top: ${pos.top}px;
		  width: ${pos.width}px;
		  height: ${pos.height}px;
		}
  `;
  };

  loadROMExercises = async (loadTime) => {
    if (!localStorage.getItem("loadSelf")) {
      return;
    }

    try {
      const res = await fetch(this.APIURL + "/api/v1/global_configuration/getGlobalROM", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ exercise: localStorage.getItem("loadSelf"), changeEx: !!window.assessmentChangeExercise }),
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const result = await res.json();
      console.log("---", result);

      window.loadedROM = result.responseData;

      if (loadTime == true && window.loadedSelfCorrectly == 1 && window.doCameraScreenStart) {
        window.doCameraScreenStart();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  getWindowSize = () => {
    return window.innerHeight;
  };

  updateMyName = (newName) => {
    if (!newName) {
      return;
    }

    window.localStorage.setItem("self_name", newName);
  };

  checkCameraSetupImage = (exercise) => {
    this.checkCameraSetupImageAPI(exercise, "", false);
  };

  checkCameraSetupImageVisible = (exercise) => {
    this.checkCameraSetupImageAPI(exercise, ["lighting", "backgroundContrast", "cameraAngle", "seatingCheck"], true);
  };

  checkCameraSetupImageAPI = (exercise, sendOptions, doCallBack) => {
    // Get camera image to be sent
    this.audioSaidLight = false;

    if (document.querySelector("#agora_ondemand_local video")) {
      const videoEl = document.querySelector("#agora_ondemand_local video");
      const videoRatio = videoEl.videoWidth / videoEl.videoHeight;

      // Calculate canvas size that keeps same ratio as video,
      // but constrained to your "useWidth"/"useHeight"
      let canvasWidth = Math.min(640, this.useWidth);
      let canvasHeight = canvasWidth / videoRatio;

      // If height is too tall, scale it down
      if (canvasHeight > this.useHeight) {
        canvasHeight = this.useHeight;
        canvasWidth = canvasHeight * videoRatio;
      }

      // Create and draw on the canvas
      const canvas = document.createElement("canvas");
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);

      var img = canvas.toDataURL();
      img = img ? img.split(",")[1] : null;

      if (img != null) {
        // Got image, send to AI for check

        try {
          // Call your backend API
          fetch(this.APIURL + "/api/v1/assessment/processimage", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ imageBase64: img, exercise: JSON.parse(exercise), checkTypes: sendOptions }),
          }).then((res) => {
            res.json().then((data) => {
              console.log("API Response (processimage):", data);

              //  Extracted bodyPosition and store in localStorage for processStart
              if (data?.data?.bodyPosition) {
                localStorage.setItem("bodyPosition", JSON.stringify(data.data.bodyPosition));
                console.log("bodyPosition saved to localStorage:", data.data.bodyPosition);
              }

              if (window.listenMyraStart) {
                window.listenMyraStart();
              }

              // If has feedback
              if (data.data && data.data.consolidatedFeedback && this.audioSaidLight == false) {
                window.mayraCode.doSay(data.data.consolidatedFeedback, () => { });
              } else if (this.audioSaidLight == false) {
                // No feedback but need to start
                setTimeout(() => {
                  if (window.completedMyraSay) {
                    window.completedMyraSay();
                  }
                }, 500);
              }
            });
          });
        } catch (err) {
          console.error("Error sending screenshot:", err);
        }
      }
    }
  };

  checkStartSetup = (exerciseData) => {
    this.audioSaidStart = false;

    this.updateTextScreen("Start sending");

    // Get camera image to be sent
    if (document.querySelector("#agora_ondemand_local video")) {
      const videoEl = document.querySelector("#agora_ondemand_local video");
      const videoRatio = videoEl.videoWidth / videoEl.videoHeight;

      // Calculate canvas size that keeps same ratio as video
      let canvasWidth = Math.min(640, this.useWidth);
      let canvasHeight = canvasWidth / videoRatio;

      // If height is too tall, scale it down
      if (canvasHeight > this.useHeight) {
        canvasHeight = this.useHeight;
        canvasWidth = canvasHeight * videoRatio;
      }

      // Create and draw on the canvas
      const canvas = document.createElement("canvas");
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);

      var img = canvas.toDataURL();
      img = img ? img.split(",")[1] : null;

      this.updateTextScreen("Start image");

      if (img != null) {
        try {
          this.updateTextScreen("Start API");
          // Retrieve bodyPosition from localStorage
          const savedBodyPosition = localStorage.getItem("bodyPosition");
          const bodyPosition = savedBodyPosition ? JSON.parse(savedBodyPosition) : {};

          // Call your backend API
          fetch(this.APIURL + "/api/v1/assessment/processstart", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ imageBase64: img, startjson: JSON.parse(exerciseData), startlandmarks: window["lastLandmarks"] ? window["lastLandmarks"] : [], bodyPosition }),
          }).then((res) => {
            res.json().then((data) => {
              console.log("API Response:", data);
              this.updateTextScreen("Got API back");

              if (data && data.success == false && this.audioSaidStart == false && data.message) {
                window.stopLightAudio();
                if (window.listenMyraStart) {
                  window.listenMyraStart();
                }
                window.mayraCode.doSay(data.message + " If you feel you are in the correct position, just say 'Myra I am in the correct starting position' and I'll start the exercise");
              }
            });
          });
        } catch (err) {
          console.error("Error sending data:", err);
          this.updateTextScreen("Error API");
        }
      }
    }
  };

  stopStartAudio = () => {
    this.audioSaidStart = true;
  };
  stopLightAudio = () => {
    this.audioSaidLight = true;
  };

  updateTextScreen = (texttoshow) => {
    // if ( document.getElementById("debugVoice") ) document.getElementById("debugVoice").innerHTML = texttoshow;

    if (!window.lastLogMessage || window.lastLogMessage !== JSON.stringify(texttoshow)) {
      window.lastLogMessage = JSON.stringify(texttoshow);

      try {
        fetch(this.APIURL + "/api/v1/assessment/saveLogs", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ log: texttoshow }),
        });
      } catch (e) { }
    }
  };

  stopMyraDestroy = () => {
    if (window.VoiceService && window.VoiceService.destroyMyraCompletely) {
      try {
        window.VoiceService.destroyMyraCompletely(true);
        console.warn('Myra closed');
      } catch (e) {
        console.error('Myra error closing', e);
      }
    } else {
      console.error('Myra error missing');
    }

    setTimeout(() => { if (window.mayraForceStop) { window.mayraForceStop(); } }, 2000);
  }

  destroyOwnedResources = () => {
    console.warn("[ondemandCamera] Destroying owned resources");

    /* ----------------------------------------------------
     * 1. STOP MEDIA STREAMS CREATED BY THIS CLASS
     * -------------------------------------------------- */
    try {
      if (this.localStream) {
        this.localStream.getTracks().forEach(t => {
          try { t.stop(); } catch (_) { }
        });
        this.localStream = null;
      }

      if (this.listOfMediaTracks?.length) {
        this.listOfMediaTracks.forEach(stream => {
          if (stream?.getTracks) {
            stream.getTracks().forEach(t => {
              try { t.stop(); } catch (_) { }
            });
          }
        });
        this.listOfMediaTracks = [];
      }
    } catch (e) {
      console.warn("Media stream cleanup error", e);
    }

    /* ----------------------------------------------------
     * 2. CLEAN ONLY THE VIDEO CREATED BY THIS FILE
     * -------------------------------------------------- */
    try {
      const container = document.querySelector("#agora_ondemand_local");
      const video = container?.querySelector("video");

      if (video) {
        try {
          video.pause();
          video.srcObject = null;
          video.src = "";
          video.load();
          video.remove();
        } catch (_) { }
      }

      if (container) {
        container.innerHTML = "";
      }
    } catch (e) {
      console.warn("Video cleanup error", e);
    }

    /* ----------------------------------------------------
     * 3. STOP VIRTUAL DETECTION LOOP
     * -------------------------------------------------- */
    this.repeatedDetection = false;
    this.cameraActive = false;

    if (this._loopTimer) {
      clearTimeout(this._loopTimer);
      this._loopTimer = null;
    }

    /* ----------------------------------------------------
     * 6. CLEAN CANVASES OWNED BY THIS CLASS
     * -------------------------------------------------- */
    try {
      // Offscreen canvas created in constructor
      if (this.simpleCtx) this.simpleCtx = null;
      if (this.simpleCanvas) {
        this.simpleCanvas.width = 0;
        this.simpleCanvas.height = 0;
        this.simpleCanvas = null;
      }

      // Flutter-related contexts (do NOT remove DOM canvases)
      this.flutterCanvas = null;
      this.drawContext = null;
      this.drawContext1 = null;
    } catch (e) {
      console.warn("Canvas cleanup error", e);
    }

    /* ----------------------------------------------------
     * 7. CLEAN AUDIO CREATED BY THIS FILE ONLY
     * -------------------------------------------------- */
    try {
      if (this.audio) {
        this.audio.pause();
        this.audio.src = "";
        this.audio.load();
        this.audio = null;
      }
    } catch (_) { }

    /* ----------------------------------------------------
     * 8. RESET INTERNAL STATE / ARRAYS
     * -------------------------------------------------- */
    this.framesArray = [];
    this.hideMasks = [];
    this.listStickMan = [];
    this.doHiding = false;
    this.sizeSetupOnce = false;

    const resetCanvas = (id) => {
      const canvas = document.getElementById(id);
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      // Reset drawing state
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = "source-over";

      // Clear visible content
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Free GPU backing store (Safari-critical)
      const w = canvas.width;
      const h = canvas.height;
      canvas.width = 0;
      canvas.height = 0;
      canvas.width = w;
      canvas.height = h;
    };

    try {
      resetCanvas("canvas-user");
      resetCanvas("canvas-flutter");
    } catch (e) {
      console.warn("React canvas reset error", e);
    }

    console.warn("[ondemandCamera] Owned resource cleanup complete");
  };



  destroyFlutterResources = () => {
    if (window.navigateBlank) { window.navigateBlank(); }

    setTimeout(() => {
      document.querySelectorAll('canvas').forEach(canvas => {
        const gl =
          canvas.getContext('webgl2') ||
          canvas.getContext('webgl') ||
          canvas.getContext('experimental-webgl');

        if (!gl) return;

        const loseExt = gl.getExtension('WEBGL_lose_context');
        if (loseExt) {
          loseExt.loseContext();
        }
      });

      // 2) Remove Flutter Web DOM nodes
      [
        'flt-glass-pane',
        'flt-scene-host',
        'flt-text-editing-host',
        'flt-semantics-host'
      ].forEach(tag => {
        document.querySelectorAll(tag).forEach(el => el.remove());
      });

      // 3) Remove any remaining canvases
      document.querySelectorAll('canvas').forEach(c => c.remove());
    }, 2000);
  }

  postSessionReload = () => {
    localStorage.setItem('loadAfterReloadAuto', '1');
    setTimeout(() => { window.location.reload(true); }, 500);
  }

  listenNative = () => {
    window.hasGetUserMedia = this.hasGetUserMedia;
    window.closeStream = this.closeStream;
    window.turnOffCamera = this.turnOffCamera;
    window.getUserPermission = this.getUserPermission;
    window.startStream = this.startStream;

    window.getMediaPipePoints = this.getMediaPipePoints;
    window.startVirtualFullDetection = this.startVirtualFullDetection;
    window.stopVirtualFullDetection = this.stopVirtualFullDetection;

    window.getListOfCameras = this.getListOfCameras;
    window.getListOfSpeakers = this.getListOfSpeakers;
    window.speakerTestOnDemand = this.speakerTestOnDemand;
    window.stopSpeakerTestOnDemand = this.stopSpeakerTestOnDemand;
    window.getLastPickedSpeaker = this.getLastPickedSpeaker;
    window.getLastPickedCamera = this.getLastPickedCamera;

    window.getCurrentVideoDevice = this.getCurrentVideoDevice;
    window.getCurrentSpeakerDevice = this.getCurrentSpeakerDevice;

    window.cameraSetupShow = this.cameraSetupShow;
    window.cameraSetupStart = this.cameraSetupStart;
    window.cameraSetupHide = this.cameraSetupHide;
    window.cameraSetupHideCamera = this.cameraSetupHideCamera;
    window.getAppVersion = this.getAppVersion;
    window.getPlatform = this.getPlatform;
    window.setVideoDevice = this.setVideoDevice;
    window.setSpeakerDevice = this.setSpeakerDevice;

    window.saveToJSONFile = this.saveToJSONFile;
    window.updateMasksArray = this.updateMasksArray;
    window.updateStickManArray = this.updateStickManArray;

    window.canvasCapture = this.canvasCapture;
    window.takeScreenshot = this.takeScreenshot;

    window.restartFlutterTransform = this.restartFlutterTransform;

    window.checkIsSelf = this.checkIsSelf;
    window.moveAfterAssesment = this.moveAfterAssesment;
    window.moveAfterAssesmentSave = this.moveAfterAssesmentSave;
    window.closeSelfVirtual = this.closeSelfVirtual;
    window.restartSelfAsses = this.restartSelfAsses;
    window.cameraBoxPosition = this.cameraBoxPosition;
    window.positionCameraView = this.cameraBoxPosition;

    this.getListOfSpeakers();
    this.getListOfCameras();

    window.loadedROM = false;
    //localStorage.setItem('dataAfterInfo', "");

    // this.loadROMExercises();
    window.loadROMExercises = this.loadROMExercises;
    window.getWindowSize = this.getWindowSize;
    window.startMyraClass = this.startMyraClass;
    window.startMyraClassSilent = this.startMyraClassSilent;
    window.isMyraActive = this.isMyraActive;

    window.updateMyName = this.updateMyName;
    window.checkCameraSetupImage = this.checkCameraSetupImage;
    window.checkCameraSetupImageVisible = this.checkCameraSetupImageVisible;
    window.checkStartSetup = this.checkStartSetup;
    window.updateTextScreen = this.updateTextScreen;
    window.getSelfLevel = this.getSelfLevel;

    window.stopStartAudio = this.stopStartAudio;
    window.stopLightAudio = this.stopLightAudio;
    window.updateNewMP = this.updateNewMP;

    window.stopMyraDestroy = this.stopMyraDestroy;
    window.destroyOwnedResources = this.destroyOwnedResources;
    window.destroyFlutterResources = this.destroyFlutterResources;

    window.postSessionReload = this.postSessionReload;

    window.startHeartbeatSession = CrashRecoveryService.startHeartbeat;
    window.stopHeartbeatSession = CrashRecoveryService.stopHeartbeat;
    window.handleIntentionalExit = CrashRecoveryService.handleIntentionalExit;
    window.clearHeartbeatSession = CrashRecoveryService.clearSession;

    window.didCrashLastTime = CrashRecoveryService.didCrashLastTime;
  };
}

export default ondemandCamera;
